// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GRkV","left":"styles_left__w1-6T","desktopActions":"styles_desktopActions__27_GN","title":"styles_title__1-m39"};